import { ExtendProps } from 'app';
import HorizontalRow from '@/components/HorizontalRow';
import { CSSProperties, HTMLAttributes } from 'react';

export default function HeadingOne(
	props: ExtendProps<
		{ horizontalRow: boolean } & HTMLAttributes<HTMLHeadingElement>
	>
) {
	return (
		<>
			<h1
				className={`font-bold text-2xl lg:text-3xl ${props.className}`}
				tabIndex={0}
			>
				{props.children}
			</h1>
			{props.horizontalRow && <HorizontalRow />}
		</>
	);
}
